<template lang="pug">
v-sheet#selectInst.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(
  color="primary lighten-5"
)
  v-container(fluid)
    v-row
      v-col
        v-row(justify="space-around" align="center")
          v-col(v-if="$vuetify.breakpoint.mdAndDown" cols=12 md=5)
            h3.mb-6.ibm.text-h4.text-md-h3.primary--text Comece a vender seus cursos agora!
          v-col(cols=12 md=5)
            v-row(justify="center" align="center")
              v-col
                v-select(
                  label="Selecione o tipo de instituição"
                  :items="institutionTypes"
                  item-text="text"
                  outlined
                  background-color="white"
                )
                v-text-field(
                  label="Nome da instituição"
                  outlined
                  background-color="white"
                )
                v-text-field(label="E-mail" outlined background-color="white")
                v-checkbox
                  template(#label)
                    span.heebo.text-body-1.text-md-h6.font-weight-regular.black--text Eu aceito receber informações e ofertas do Erudio por e-mail.
            v-row(justify="center" align="center")
              v-col
                v-btn.heebo.text-body-1.font-weight-medium.text-none(
                  color="primary accent-2"
                  block
                  depressed
                  height=56
                ) Quero começar minhas vendas
          v-col(v-if="$vuetify.breakpoint.lgAndUp" cols=12 md=5)
            h3.ibm.text-h3.primary--text Comece a vender seus cursos agora!
</template>

<script>
export default {
  components: {},
  data: () => ({
    institutionTypes: [
      {
        slug: 'escola',
        text: 'Escola'
      },
      {
        slug: 'faculdade',
        text: 'Faculdade'
      },
      {
        slug: 'cursinho',
        text: 'Cursinho'
      },
      {
        slug: 'pessoa-fisica',
        text: 'Pessoa física'
      },
      {
        slug: 'empresa',
        text: 'Empresa'
      }
    ]
  })
}
</script>

<style lang="sass" scoped></style>
